import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { RecommendedPageBannerNoContentProps } from './RecommendedPageBannerNoContent.ts';

export const RecommendedPageBannerNoContent: LoadableType<RecommendedPageBannerNoContentProps> =
	LoadablePaint({
		loader: () =>
			import(
				/* webpackChunkName: "loadable-RecommendedPageBannerNoContent" */ '../src/RecommendedPageBannerNoContent.tsx'
			).then((module) => module.RecommendedPageBannerNoContent),
	});

export type {
	BannerTemplateKey,
	RecommendedPageBannerNoContentProps,
} from '../src/RecommendedPageBannerNoContent.tsx';
